import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  actionsAddingMaterial: {
    marginTop: "30px",
    flexWrap: "nowrap",
  },
  iconButton: {
    padding: "0",
  },
}));

export default styles;
